import { AfterViewInit, Component, ElementRef, input, InputSignal } from '@angular/core';
import { GraphConfig } from '../../activity.service';

declare const Highcharts: any;

@Component({
    selector: 'highcharts-column',
    template: '',
    styles: [`
        :host {
            display: block;
            height: 228px;
        }
    `]
})
export class HighchartsColumnComponent implements AfterViewInit {
    constructor(private _elRef: ElementRef) {}

    config: InputSignal<GraphConfig> = input(null, { transform: this.drawChart.bind(this) });

    ngAfterViewInit(): void {
        // http://www.highcharts.com/plugin-registry/single/9/Pattern-Fill
        this.drawChart(this.config());
    }

    drawChart(config: GraphConfig): GraphConfig {
        if (config && this._elRef) {
            Highcharts.chart(this._elRef.nativeElement, config);
        }
        return config;
    }
}
